export class BaseException extends Error
{
    constructor(message)
    {
        super(message);
        this.name = BaseException.name;

        // Work around for 'instanceof' not working as expected
        // https://github.com/babel/babel/issues/4485#issuecomment-315569892
        this.constructor = BaseException 
        this.__proto__   = BaseException.prototype

        if (typeof Error.captureStackTrace === 'function')
        {
            Error.captureStackTrace(this, BaseException);
        }
        else
        {
            this.stack = (new Error(message)).stack; 
        }
    }
}